import { Trans, useLingui } from '@lingui/react/macro';

import { BaseMoneyCell } from '@/components/ArticlesTableCells';
import Stack from '@/design_system/Stack';
import { Cell, Row } from '@/design_system/Table/Table';
import InlineText from '@/design_system/Typography/InlineText';
import Paragraph from '@/design_system/Typography/Paragraph';
import { ArticleWithRelations } from '@/models/request';

export const ArticlePriceRow = ({
  article,
  showDefectsColumn,
}: {
  article: ArticleWithRelations;
  showDefectsColumn: boolean;
}) => {
  return (
    <Row className="bg-neutral-200">
      <Cell>
        <Paragraph>
          <Trans id="client.article.services.total">Total</Trans>
        </Paragraph>
      </Cell>
      {showDefectsColumn && <Cell />}
      <Cell justifyContent="flex-end">
        <ArticlePrice article={article} />
      </Cell>
    </Row>
  );
};

export const ArticlePriceCardFooter = ({ article }: { article: ArticleWithRelations }) => {
  return (
    <Stack
      padding="12px"
      gap="0.5rem"
      row
      alignItems="center"
      justifyContent="space-between"
      className="bg-neutral-200"
      style={{ borderTop: '1px solid var(--color-neutral-300)' }}
    >
      <InlineText>
        <Trans id="client.article.services.total">Total</Trans>
      </InlineText>
      <ArticlePrice article={article} />
    </Stack>
  );
};

const ArticlePrice = ({ article }: { article: ArticleWithRelations }) => {
  const { t } = useLingui();

  const clientRefusalBadgeText =
    article.cancellationDetail?.type === 'requestor_refusal'
      ? t({
          id: 'client.articles.service-refused',
          message: 'Service refused',
        })
      : undefined;

  return (
    <BaseMoneyCell
      price={article.snapshot.organizationPrice?.amountPerCurrency?.[0]}
      clientRefusalBadgeText={clientRefusalBadgeText}
      showAmountBeforeTaxes={false}
    />
  );
};
